__turbopack_context__.v({
  "root": "FullWidthContainer-module-scss-module__tCnF0G__root",
  "root_slider": "FullWidthContainer-module-scss-module__tCnF0G__root_slider",
  "root_subsection": "FullWidthContainer-module-scss-module__tCnF0G__root_subsection",
});
